import { makeCustomIcon } from './utils';

export const statBarsIcon = makeCustomIcon(
  'StatBars',
  20,
  32,
  'M10 6.5h10v4h-10zM5 14.5h15v4h-15zM0 22.5h20v4h-20z',
);
